import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2 } from 'lucide-react';
const points = ['Cómo hacer la transición sin riesgos desde el pienso', 'Qué alimentos usar y cuáles evitar sin dudas', 'Cómo introducir nuevos ingredientes correctamente', 'Cómo detectar si algo no le está sentando bien', 'Cómo organizarte sin perder tiempo ni gastar más dinero', 'Señales claras para evaluar la salud de tu mascota', 'Errores comunes que debes evitar'];
export function BeyondRecipes() {
  return <section className="py-12 md:py-24 bg-dark-900" data-id="element-21">
      <div className="container mx-auto px-6 max-w-5xl" data-id="element-22">
        <div className="grid md:grid-cols-2 gap-16 items-center" data-id="element-23">
          <motion.div initial={{
          opacity: 0,
          x: -30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.8
        }} data-id="element-24">
            <h2 className="text-3xl md:text-5xl font-bold text-white mb-6" data-id="element-25">
              Es el punto de control que te faltaba.
            </h2>
            <p className="text-lg text-gray-400 mb-8" data-id="element-26">
              Lo que realmente diferencia esta guía es su enfoque práctico y
              responsable. Aprenderás a organizarte de forma eficiente:
              preparación por lotes, conservación correcta y planificación
              semanal.
            </p>
            <p className="text-xl text-earth-amber font-serif italic" data-id="element-27">
              Sin improvisar. Sin copiar lo que hace otro. Sin poner en riesgo
              su salud.
            </p>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          x: 30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.8
        }} className="bg-dark-800 p-8 rounded-2xl border border-dark-800" data-id="element-28">
            <h3 className="text-2xl font-bold text-white mb-6 border-b border-gray-700 pb-4" data-id="element-29">
              Además aprenderás:
            </h3>
            <ul className="space-y-4" data-id="element-30">
              {points.map((point, index) => <motion.li key={index} initial={{
              opacity: 0,
              y: 10
            }} whileInView={{
              opacity: 1,
              y: 0
            }} viewport={{
              once: true
            }} transition={{
              delay: index * 0.1
            }} className="flex items-start gap-3" data-id="element-31">
                  <CheckCircle2 className="w-6 h-6 text-earth-green shrink-0 mt-0.5" data-id="element-32" />
                  <span className="text-gray-300" data-id="element-33">{point}</span>
                </motion.li>)}
            </ul>
          </motion.div>
        </div>
      </div>
    </section>;
}